import React from 'react';

import { link, routes } from '@aline/routes';
import { Helmet } from 'react-helmet';
import { Navigate, Route, Routes } from 'react-router-dom';
import { CommunityLeftPanel } from 'src/components/community';
import { createRelativeRouter } from 'src/helpers/router-helpers';
import { makeStyles } from 'tss-react/mui';

import { CommunityTemplateBody } from '../documents/CommunityTemplateBody';
import { CommunityPageHeader } from '../header/CommunityPageHeader';
import { CommunityTabs } from '../header/CommunityTabs';
import { CommunityWorkflowBody } from '../workflows/CommunityWorkflowBody';
import { CommunityWorkflowDetailPage } from '../workflows/CommunityWorkflowDetailPage';

const useStyles = makeStyles()(theme => ({
  pageContainer: {
    flexGrow: 1,
    height: '100%',
    overflowY: 'auto',
  },
  pageSubContainer: {
    padding: theme.spacing(2),
  },
  wrapper: {
    display: 'flex',
    flexGrow: 1,
    flexWrap: 'nowrap',
    width: '100%',
  },
}));

const { toRelativePath: toRelativeCommunityPath } = createRelativeRouter(routes.CommunityIndex, {
  nestedRoutes: true,
});

export function CommunityPage(): JSX.Element | null {
  return (
    <>
      <Helmet>
        <title>Aline Community</title>
      </Helmet>
      <Routes>
        <Route
          element={<CommunityWorkflowDetailPage />}
          path={toRelativeCommunityPath(routes.CommunityWorkflowDetail)}
        />
        <Route
          element={<CommunityMainPage />}
          path={toRelativeCommunityPath(routes.CommunityIndex)}
        />
        <Route element={<Navigate replace to={link.CommunityDocumentIndex()} />} path="/" />
      </Routes>
    </>
  );
}

export const communityTemplatePaths = [
  routes.CommunityDocumentIndex,
  routes.CommunityCategoryDocuments,
];
export const communityWorkflowPaths = [
  routes.CommunityWorkflowIndex,
  routes.CommunityCategoryWorkflows,
];

export function CommunityMainPage(): JSX.Element {
  const { classes } = useStyles();

  return (
    <>
      <Helmet>
        <title>Aline Community</title>
      </Helmet>
      <div className={classes.wrapper}>
        <CommunityLeftPanel />
        <div className={classes.pageContainer}>
          <CommunityPageHeader />
          <div className={classes.pageSubContainer}>
            <Routes>
              <Route
                element={
                  <>
                    <CommunityTabs />
                    <CommunityTemplateBody />
                  </>
                }
                path={routes.CommunityDocumentIndex}
              />
              <Route
                element={
                  <>
                    <CommunityTabs />
                    <CommunityTemplateBody />
                  </>
                }
                path={routes.CommunityCategoryDocuments}
              />
              <Route
                element={
                  <>
                    <CommunityTabs />
                    <CommunityWorkflowBody />
                  </>
                }
                path={routes.CommunityWorkflowIndex}
              />
              <Route
                element={
                  <>
                    <CommunityTabs />
                    <CommunityWorkflowBody />
                  </>
                }
                path={routes.CommunityCategoryWorkflows}
              />
            </Routes>
          </div>
        </div>
      </div>
    </>
  );
}
